import { Icon as _Icon } from 'tdesign-icons-vue-next';
import { withInstall } from '../shared';

export const Icon = withInstall(_Icon, 'TIcon');
export default Icon;
